// extracted by mini-css-extract-plugin
export var black = "_2q-6";
export var brand = "_2q-1";
export var ddefault = "_2q-0";
export var error = "_2q-3";
export var gray = "_2q-2";
export var highContrast = "_2q-8";
export var outline = "_2q-7";
export var success = "_2q-5";
export var warning = "_2q-4";